import { useEffect, useState } from "react";
import { BusinessProdutoDTO, CarrinhoProdutoDTO } from "../DTOs/produtoDTO";
import api from "../service/api";
import { ProdutoFiltro } from "../DTOs/ProdutoFiltro";
import produtoSemCapa from '../assets/img/no_image_large.jpg'
import { formatarValores } from "../helpers/valores";
import { useQuery } from "@tanstack/react-query";

const useProdutosQuery = (filtro: ProdutoFiltro) => {
    // const [produtos, setProdutos] = useState<CarrinhoProdutoDTO[]>([]);
    // const [removeLoading, setRemoveLoading] = useState(false);

    const fetchProdutos = () => {

        const resultado = api
            .post<BusinessProdutoDTO[]>(`api/business/produto`, filtro)
            .then((res) => res.data.map(({
                Codproduto, Nomproduto, Vlrvenda, Codautor, Nomautor, Codeditora, Nomeditora, Desconto, Qtdestoque,
                QuantidadeEmEstoque, Pathimagem, Inddestaque, Indlancamento, Indprevenda, Dscsituacaoestoque }: BusinessProdutoDTO) => {
                var result: CarrinhoProdutoDTO = {
                    CodProduto: Codproduto, Src: Pathimagem != null ? process.env.REACT_APP_IMAGEMPATH + Pathimagem : produtoSemCapa,
                    Titulo: Nomproduto, Vlr: Vlrvenda, Disponibilidade: "", CodEditora: Codeditora, NomEditora: Nomeditora, CodAutor: Codautor,
                    NomAutor: Nomautor, Desconto: Desconto, Qtdestoque: Qtdestoque, QuantidadeEmEstoque: QuantidadeEmEstoque, VlrFormatado: formatarValores(Vlrvenda),
                    Inddestaque: Inddestaque, Indlancamento: Indlancamento, Indprevenda: Indprevenda, Dscsituacaoestoque: Dscsituacaoestoque
                };
                return result;
            }
            )
            );

        return resultado;
    }

    return useQuery({
        queryKey: [filtro.Titulo],
        queryFn: fetchProdutos,
        staleTime: 1000 * 60 * 5
    });

}

export default useProdutosQuery;